import type React from 'react'
import { Box, MenuItem, Select, Typography } from '@mui/material'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'
import { color } from 'config/color'
import { ErrorText } from 'components'

interface MenuItems {
  label: string
  value: string
}


interface DropDownProps {
  fieldName: string
  fieldLabel: string
  fieldType: string
  control: Control<any>
  errors: FieldErrors<any>
  placeholder?: string
  options: string[] | MenuItems[]
}

export const DropDown: React.FC<DropDownProps> = (props: DropDownProps) => {
  const labelId = `dropdown-label-${props.fieldName}`
  const selectId = `dropdown-${props.fieldName}`
  const errorId = `error-dropdown-${props.fieldName}`

  return (
    <Box mb={2}>
      <Controller
        name={props.fieldName}
        control={props.control}
        render={({ field }) => {
          const hasError = props.errors[props.fieldName] != null
          return (
            <Box>
              <Typography
                id={labelId}
                component="span"
                display="block"
                sx={{
                  fontSize: 12,
                  color: color.grey[700],
                  textTransform: 'uppercase',
                  letterSpacing: 2,
                  marginBottom: '5px',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word'
                }}
              >
                {props.fieldLabel.toUpperCase()}
              </Typography>
              <Select
                fullWidth
                renderValue={(value) =>
                  value.length !== 0
                    ? (
                      <Typography>{value}</Typography>
                    )
                    : (
                      <Typography sx={{ color: '#737373' }} fontSize="medium">
                        {props.placeholder}
                      </Typography>
                    )
                }
                displayEmpty={true}
                {...field}
                id={selectId}
                labelId={labelId}
                inputProps={{
                  'aria-labelledby': labelId,
                  'aria-invalid': hasError,
                  'aria-describedby': hasError ? errorId : undefined
                }}
              >
                {props.options.map((item, index) => {
                  if (typeof item === 'string') {
                    return (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    )
                  } else {
                    return (
                      <MenuItem key={index} value={item.value}>
                        {item.label}
                      </MenuItem>
                    )
                  }
                })}
              </Select>
              {hasError && (
                <ErrorText id={errorId} role="alert">
                  {String(props.errors[props.fieldName]?.message)}
                </ErrorText>
              )}
            </Box>
          )
        }}
      />
    </Box>
  )
}
